export default __webpack_public_path__ + "static/media/ug.56bf169c.svg";